export default __webpack_public_path__ + "static/media/sh.3a416f06.svg";